<template>
    <v-card>
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                Register Production
            </h2>
        </v-card-title>
        <v-divider class="mx-6" />
        <v-card-text
            :style="{ 'max-height': `${height}px`, 'overflow-y': 'auto' }"
        >
            <v-form ref="form" v-model="valid">
                <v-data-table
                    :headers="headers"
                    :items="filteredItems"
                    class="elevation-0 mt-7"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="mt-0 mx-0 pt-4 pb-0 pb-4"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="4" class="d-flex align-center">
                                <h2 class="my-n3 d-flex align-center">
                                    ITEMS
                                </h2></v-col
                            >
                            <v-col cols="4" class="d-flex justify-end"
                                ><v-combobox
                                    v-model="selectedProcess"
                                    hide-details
                                    prefix="Process *"
                                    prepend-icon="mdi-tools"
                                    :items="availableProcesses"
                                    item-text="name"
                                    :rules="[rules.required]"
                                    required
                                    class="ma-0 pa-0"
                                    :style="{ width: '100px' }"
                                    @change="getProcessMachines"
                                />
                            </v-col>
                            <v-col cols="4" class="d-flex justify-end"
                                ><v-combobox
                                    v-model="selectedMachine"
                                    hide-details
                                    prefix="Machine *"
                                    prepend-icon="mdi-tools"
                                    :items="processMachines"
                                    item-text="name"
                                    required
                                    class="ma-0 pa-0"
                                    :style="{ width: '100px' }"
                                    @change="setDefaultMachine"
                                />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`header.partNumber`]="{ header }">
                        <v-text-field
                            :label="header.text"
                            v-model="partNumberToFilter"
                            dense
                            class="pt-2"
                            @input="verifyCheckBox"
                        />
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.index`]="{ index }">
                        <p class="my-0">
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">{{ item.code }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <div>
                            <p class="my-0">{{ item.description }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.availableQty`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">
                                {{ Math.floor(+item.availableQty) }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.machine`]="{ item }">
                        <v-combobox
                            v-model="item.machine"
                            hide-details
                            placeholder="Machine*"
                            :items="item.processMachines"
                            item-text="name"
                            :rules="[rules.required]"
                            required
                            class="mt-n1 pt-0"
                        />
                    </template>
                    <template v-slot:[`item.qty`]="{ item }">
                        <div class="mb-5">
                            <v-text-field
                                v-model="item.qtyToSend"
                                hide-details
                                type="number"
                                min="0"
                                step="1"
                                :rules="[() => maxValue(item)]"
                                @input="verifyCheckBox"
                                @keypress="onlyInteger"
                            />
                        </div>
                    </template>
                    <template v-slot:no-data>
                        <v-alert type="info" class="mx-4 my-2" text>
                            No items available for the selected process.
                        </v-alert>
                    </template>
                </v-data-table>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-row
                v-if="!partNumberToFilter"
                class="ml-1 d-flex justify-left align-center"
            >
                <v-simple-checkbox
                    color="primary"
                    v-model="setAvailable"
                    @click="setAllAvailable"
                    class="ml-2 d-flex justify-center align center"
                >
                </v-simple-checkbox>
                <small>Select All Available Quantities</small>
            </v-row>
            <v-row v-else class="ml-1 d-flex justify-left align-center">
                <v-simple-checkbox
                    color="primary"
                    v-model="setAvailableInFiltered"
                    @click="setAllAvailableInFiltered"
                    class="ml-2 d-flex justify-center align center"
                >
                </v-simple-checkbox>
                <small>Set Available Quantities In Filtered Items</small>
            </v-row>

            <v-spacer />
            <v-btn
                :loading="loading"
                color="primary"
                rounded
                class="mb-3 mr-3"
                :disabled="disableButton()"
                @click="openConfirmDialog"
            >
                NEXT
            </v-btn>
        </v-card-actions>
        <v-dialog
            :retain-focus="false"
            v-model="confirmDialog"
            persistent
            max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="closeConfirmDialog"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">
                        Confirm Production -
                        {{ selectedProcess ? selectedProcess.name : '' }}
                    </h2>
                </v-card-title>
                <v-divider class="mx-6" />
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                        <v-data-table
                            :headers="confirmHeaders"
                            :items="
                                items.filter(
                                    i => i.qtyToSend && i.qtyToSend > 0
                                )
                            "
                            class="elevation-0 mt-7"
                            :mobile-breakpoint="0"
                            :loading="loading"
                            disable-pagination
                            hide-default-footer
                            :style="{
                                'max-height': `${height}px`,
                                'overflow-y': 'auto',
                            }"
                        >
                            <template v-slot:top>
                                <v-row
                                    no-gutter
                                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                                    :style="{ 'background-color': '#eeeeee' }"
                                >
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                    >
                                        <h2 class="my-n3 d-flex align-center">
                                            ITEMS
                                        </h2></v-col
                                    >
                                </v-row>
                            </template>
                            <!--ITEMS-->
                            <template v-slot:[`item.code`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.code }}</p>
                                </div>
                            </template>
                            <template v-slot:[`item.machine`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.machine.name }}</p>
                                </div>
                            </template>
                            <template v-slot:[`item.qty`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.qtyToSend }}</p>
                                </div>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-5">
                    <v-row class="ma-2">
                        <!-- Batch Progress Indicator -->
                        <div
                            v-if="batchProgress.isProcessing"
                            class="d-flex align-center mr-4"
                        >
                            <span class="text-caption">
                                Processing batch {{ batchProgress.current }} of
                                {{ batchProgress.total }}
                            </span>
                        </div>
                        <v-spacer />
                        <v-col cols="3" class="d-flex justify-end pa-0 ">
                            <v-btn
                                v-if="forAssemblyOrder"
                                color="primary"
                                rounded
                                :loading="loading"
                                @click="openAssemblyComponentsDialog"
                            >
                                CONTINUE
                            </v-btn>
                            <v-btn
                                v-else
                                color="primary"
                                rounded
                                :loading="loading"
                                :disabled="batchProgress.isProcessing"
                                @click="registerItems"
                            >
                                <v-icon v-if="batchProgress.isProcessing" left
                                    >mdi-loading</v-icon
                                >
                                {{
                                    batchProgress.isProcessing
                                        ? 'PROCESSING...'
                                        : 'SAVE'
                                }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            :retain-focus="false"
            v-model="assemblyComponentsDialog"
            persistent
            max-width="1200px"
        >
            <AssemblyComponents
                v-if="assemblyComponentsDialog"
                :productionInfo="productionInfo"
                :itemsToProduce="itemsToProduce"
                :workOrder="workOrder"
                :selectedProcess="selectedProcess"
                @registerItems="registerItems"
                @closeDialog="closeComponentsDialog"
                @closeAll="closeAll"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import lodash from 'lodash'
import API from '@/services/api'
import _ from 'lodash'

export default {
    name: 'MultipleRegister',
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        forAssemblyOrder: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        AssemblyComponents: () =>
            import('@/components/WorkOrders/AssemblyComponents.vue'),
    },
    data: () => ({
        valid: false,
        loading: false,
        batchSize: 100, // Number of items to process per batch
        batchProgress: {
            current: 0,
            total: 0,
            isProcessing: false,
        },
        batchInfo: {
            totalItems: 0,
            totalBatches: 0,
            itemsPerBatch: 100,
        },
        headers: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'AVAILABLE QTY',
                value: 'availableQty',
                align: 'center',
                sortable: false,
                width: '130',
            },
            {
                text: 'MACHINE',
                value: 'machine',
                align: 'center',
                sortable: false,
                width: '130',
            },
            {
                text: 'PRODUCED QTY',
                value: 'qty',
                align: 'center',
                sortable: false,
                width: '130',
            },
        ],
        confirmHeaders: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'MACHINE',
                value: 'machine',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PRODUCED QTY',
                value: 'qty',
                align: 'center',
                sortable: false,
            },
        ],
        rules: {
            required: v => !!v || 'The value is required',
        },

        availableProcesses: [],
        prevProcess: undefined,
        selectedProcess: undefined,
        confirmCode: undefined,
        code: undefined,
        confirmDialog: false,
        height: 0,
        partNumberToFilter: undefined,
        machines: [],
        items: [],
        processMachines: [],
        selectedMachine: undefined,
        setAvailable: false,
        setAvailableInFiltered: false,
        assemblyComponentsDialog: false,
        productionInfo: [],
        itemsToProduce: [],
    }),
    computed: {
        filteredItems() {
            let conditions = []

            conditions.push(
                item =>
                    Array.isArray(item.processes) &&
                    item.processes.includes(this.selectedProcess.id)
            )

            conditions.push(this.filterAvailable)

            if (this.partNumberToFilter) {
                conditions.push(this.filterForPartNumber)
            }

            return this.items.filter(item =>
                conditions.every(cond => cond(item))
            )
        },
    },
    watch: {
        'workOrder.items': {
            handler(newItems) {
                if (!newItems?.length) return
                newItems.forEach(freshItem => {
                    const localItem = this.items.find(
                        i =>
                            i.id === freshItem.id ||
                            i.partNumberId === freshItem.partNumberId
                    )
                    if (localItem) {
                        localItem.production = freshItem.production
                        localItem.deliveries = freshItem.deliveries
                        this.calculateValues(
                            localItem,
                            this.selectedProcess?.id
                        )
                    }
                })
            },
            deep: true,
        },
    },
    mounted() {
        this.items = []

        if (Array.isArray(this.user.process)) {
            this.availableProcesses = this.user.process.map(proc => {
                if (!proc.name && proc.description) {
                    proc.name = proc.description
                    delete proc.description
                }
                return proc
            })

            this.selectedProcess = this.availableProcesses[0]
        }

        this.machines = this.settings.machines

        this.workOrder.items.forEach(item => {
            const copy = lodash.cloneDeep(item)
            copy.qtyToSend = 0
            copy.machine = undefined
            this.calculateValues(copy, this.selectedProcess?.id)
            this.items.push(copy)
        })

        this.getProcessMachines()

        this.onResize()
    },

    methods: {
        ...mapMutations(['setErrorItems']),

        calculateValues(item, processId) {
            try {
                const processes = item.processes.map(id =>
                    item.dataProcesses.find(p => p.id === id)
                )

                const processIndex = processes.findIndex(
                    p => p.id === processId
                )
                if (processIndex < 0) return

                const prevProcess =
                    processIndex > 0 ? processes[processIndex - 1] : null
                item.prevProcess = prevProcess

                let totalProduced = 0
                let totalDelivered = 0

                if (item.deliveries) {
                    const delivered = item.deliveries.filter(
                        d => d.nextProcess?.id === processId
                    )
                    totalDelivered = delivered.reduce(
                        (sum, d) => sum + (d.receivedBy ? d.qty : 0),
                        0
                    )
                }

                if (processIndex == 0 && !this.workOrder.assemblyWorkOrder) {
                    totalDelivered += item.quantity
                }
                if (processIndex == 0 && this.workOrder.assemblyWorkOrder) {
                    totalDelivered = item.quantity
                    //TODO: Implement assembly items delivery calculation
                    // if (item.assemblyItems) {
                    //     item.assemblyItems.forEach(ai => {
                    //         let receivedQty = 0
                    //         if (ai.deliveries) {
                    //             receivedQty = ai.deliveries.reduce(
                    //                 (accumulator, delivery) =>
                    //                     accumulator + delivery.qty,
                    //                 0
                    //             )
                    //         }
                    //         const assemblyQty = receivedQty / ai.qtyPerAssembly
                    //         if (assemblyQty < totalDelivered) {
                    //             totalDelivered = assemblyQty
                    //         }
                    //     })
                    // }
                }

                if (item.production) {
                    const produced = item.production.filter(
                        p => p.process?.id === processId
                    )
                    totalProduced = produced.reduce((sum, p) => sum + p.qty, 0)
                }

                item.availableQty = totalDelivered - totalProduced

                item.processMachines = this.machines.filter(
                    m => m.process === processId
                )
            } catch (error) {
                console.error(error)
            }
        },
        async openAssemblyComponentsDialog() {
            for (let item of this.items) {
                const productionInFirstProcess =
                    item.processes[0] == this.selectedProcess.id

                // separe the items that are producing the first process from the items that are producing other processes
                if (productionInFirstProcess) {
                    this.productionInfo.push({
                        item: item,
                        productionQty: item.qtyToSend,
                        selectedMachine: item.machine,
                    })
                } else {
                    this.itemsToProduce.push(item)
                }
            }
            this.assemblyComponentsDialog = true
        },
        async registerItems(entryItems = null) {
            try {
                this.loading = true
                const items = entryItems?.length ? entryItems : this.items

                let filteredItems = items.filter(
                    i => i.qtyToSend && i.qtyToSend > 0
                )

                let itemsToRegister = filteredItems.map(fi => {
                    const machine = _.cloneDeep(fi.machine)
                    delete machine.process
                    delete machine.description
                    return {
                        partNumberId: fi.partNumberId,
                        qtyToSend: fi.qtyToSend,
                        machine: machine,
                    }
                })

                // Process items in batches
                const allProcessedItems = []
                const totalBatches = Math.ceil(
                    itemsToRegister.length / this.batchSize
                )

                // Initialize batch progress
                this.batchProgress = {
                    current: 0,
                    total: totalBatches,
                    isProcessing: true,
                }

                for (
                    let i = 0;
                    i < itemsToRegister.length;
                    i += this.batchSize
                ) {
                    const batch = itemsToRegister.slice(i, i + this.batchSize)
                    const currentBatchNumber =
                        Math.floor(i / this.batchSize) + 1

                    // Update progress
                    this.batchProgress.current = currentBatchNumber

                    try {
                        const batchResult = await API.multipleProductionRegister(
                            {
                                items: batch,
                                workOrderId: this.workOrder.id,
                                process: this.selectedProcess,
                            }
                        )

                        // Handle different response formats
                        if (Array.isArray(batchResult)) {
                            allProcessedItems.push(...batchResult)
                        } else if (
                            batchResult &&
                            typeof batchResult === 'object'
                        ) {
                            // If it's an object, check if it has a data property or items property
                            if (
                                batchResult.data &&
                                Array.isArray(batchResult.data)
                            ) {
                                allProcessedItems.push(...batchResult.data)
                            } else if (
                                batchResult.items &&
                                Array.isArray(batchResult.items)
                            ) {
                                allProcessedItems.push(...batchResult.items)
                            } else {
                                // If it's just a single object, push it directly
                                allProcessedItems.push(batchResult)
                            }
                        } else {
                            // If it's not an array or object, just push it as is
                            allProcessedItems.push(batchResult)
                        }

                        // Optional: Add a small delay between batches to prevent overwhelming the server
                        if (i + this.batchSize < itemsToRegister.length) {
                            await new Promise(resolve =>
                                setTimeout(resolve, 100)
                            )
                        }
                    } catch (error) {
                        this.setErrorItems({
                            source: this.$options.name,
                            message: error.message,
                        })
                    }
                }

                // Reset batch progress
                this.batchProgress.isProcessing = false

                this.$emit('replaceItems', allProcessedItems)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        matchCode() {
            return !!(
                this.code &&
                this.confirmCode &&
                this.code === this.confirmCode
            )
        },

        openConfirmDialog() {
            this.$refs.form.validate()

            // Calculate batch information
            const selectedItems = this.items.filter(
                i => i.qtyToSend && i.qtyToSend > 0
            )
            this.batchInfo = {
                totalItems: selectedItems.length,
                totalBatches: Math.ceil(selectedItems.length / this.batchSize),
                itemsPerBatch: this.batchSize,
            }

            this.confirmDialog = true
        },

        closeConfirmDialog() {
            this.confirmDialog = false
        },

        close() {
            this.$emit('closeDialog')
        },

        disableButton() {
            const selectedItems = this.items.filter(item => +item.qtyToSend > 0)
            const completeForm = selectedItems.every(
                i => i.machine && i.qtyToSend <= i.availableQty
            )
            return (
                selectedItems.length == 0 ||
                !completeForm ||
                this.batchProgress.isProcessing
            )
        },

        onResize() {
            this.height = window.innerHeight - 260
        },

        filterAvailable(item) {
            return item.availableQty && item.availableQty > 0
        },

        filterForPartNumber(item) {
            return (
                item.partNumber &&
                item.partNumber
                    .toLowerCase()
                    .includes(this.partNumberToFilter.toLowerCase())
            )
        },
        maxValue(item) {
            return item.qtyToSend > item.availableQty || item.qtyToSend <= 0
                ? 'The quantity to be sent cannot be greater than the quantity available'
                : true
        },
        onlyInteger(event) {
            // Prevent decimal point, comma, minus, plus, and e (exponential)
            const char = String.fromCharCode(event.keyCode || event.which)
            if (['.', ',', '-', '+', 'e', 'E'].includes(char)) {
                event.preventDefault()
            }
        },
        getProcessMachines() {
            if (!this.selectedProcess) return

            this.processMachines = this.machines.filter(
                machine => machine.process === this.selectedProcess.id
            )

            this.selectedMachine = undefined

            const validMachineIds = new Set(this.processMachines.map(m => m.id))

            this.items.forEach(item => {
                this.calculateValues(item, this.selectedProcess?.id)

                const isCompatible = item.processes.includes(
                    this.selectedProcess.id
                )

                if (!isCompatible) {
                    item.machine = undefined
                    item.qtyToSend = undefined
                } else if (
                    item.machine &&
                    !validMachineIds.has(item.machine.id)
                ) {
                    item.machine = undefined
                    item.qtyToSend = 0
                }
            })
        },

        setDefaultMachine() {
            this.items.forEach(item => {
                item.machine = this.selectedMachine
            })
        },
        setAllAvailable() {
            this.items.forEach(item => {
                if (
                    this.setAvailable &&
                    item.availableQty &&
                    item.availableQty > 0
                ) {
                    item.qtyToSend = Math.floor(Number(item.availableQty))
                } else {
                    delete item.qtyToSend
                }
            })
        },
        verifyCheckBox() {
            if (this.filteredItems.length > 0) {
                this.setAvailable = !this.items.some(
                    item => (item.qtyToSend || 0) < item.availableQty
                )
                this.setAvailableInFiltered = !this.filteredItems.some(
                    item => (item.qtyToSend || 0) < item.availableQty
                )
            }
        },
        setAllAvailableInFiltered() {
            this.items.forEach(item => {
                if (
                    this.setAvailableInFiltered &&
                    item.availableQty &&
                    item.availableQty > 0 &&
                    item.partNumber
                        .toLowerCase()
                        .includes(this.partNumberToFilter.toLowerCase())
                ) {
                    item.qtyToSend = Math.floor(Number(item.availableQty))
                } else if (
                    !this.setAvailableInFiltered &&
                    item.partNumber
                        .toLowerCase()
                        .includes(this.partNumberToFilter.toLowerCase())
                ) {
                    delete item.qtyToSend
                }
            })
        },
        closeComponentsDialog() {
            this.productionInfo = []
            this.assemblyComponentsDialog = false
        },
        closeAll() {
            this.productionInfo = []
            this.assemblyComponentsDialog = false
            this.$emit('closeDialog')
        },
    },
}
</script>

<style></style>
